import { Component, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({ standalone: true, selector: 'app-table-column', template: '' })
export class TableColumnComponent {
  @Input() header = '';
  @Input() align: 'left' | 'center' | 'right' = 'left';
  @Input() width?: string;
  @Input() field?: string;
  @Input() value?: (row: any) => any;
  @Input() exportable = true;
  @ContentChild(TemplateRef) cell?: TemplateRef<any>;

  read(row: any): any {
    if (this.value) return this.value(row);
    if (this.field) return row?.[this.field];
    return '';
  }
}
